import { useEffect } from "react";
import { applyBrand, isBrandColor } from "@/lib/brand";
import { useCustomerStore } from "@/store";

/**
 * Publishes a brand on `<html>` for the resolved theme, and again whenever the
 * OS theme flips. An absent or invalid brand writes nothing, so whatever is
 * already painted (the pre-paint, or the previous brand) stays: `applyBrand`
 * would otherwise paint the default over a remembered brand while the real one
 * is still loading.
 */
export function useApplyBrand(brand: string | null | undefined): void {
  const resolvedTheme = useCustomerStore((s) => s.resolvedTheme);

  useEffect(() => {
    if (!isBrandColor(brand)) return;
    applyBrand(brand, resolvedTheme);
  }, [brand, resolvedTheme]);
}
